/// <reference types="vite/client" />

/**
 * Environment configuration for Voltaire AI frontend.
 * Loads configuration from Vite environment variables.
 */

interface EnvConfig {
  apiUrl: string;
  enableAnalytics: boolean;
  enableDebug: boolean;
  appName: string;
  appVersion: string;
  isDevelopment: boolean;
  isProduction: boolean;
}

const getEnvVar = (key: string, defaultValue: string = ''): string => {
  return import.meta.env[key] || defaultValue;
};

const getEnvBool = (key: string, defaultValue: boolean = false): boolean => {
  const value = import.meta.env[key];
  if (value === undefined) return defaultValue;
  return value === 'true';
};

export const env: EnvConfig = {
  apiUrl: getEnvVar('VITE_API_URL', 'http://localhost:8000'),
  enableAnalytics: getEnvBool('VITE_ENABLE_ANALYTICS', false),
  enableDebug: getEnvBool('VITE_ENABLE_DEBUG', true),
  appName: getEnvVar('VITE_APP_NAME', 'Voltaire AI'),
  appVersion: getEnvVar('VITE_APP_VERSION', '0.0.0'),
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
};

// Debug logging in development
if (env.enableDebug) {
  console.log('Environment Config:', {
    apiUrl: env.apiUrl,
    appName: env.appName,
    appVersion: env.appVersion,
    isDevelopment: env.isDevelopment,
    isProduction: env.isProduction,
  });
}

// Validate required config
if (!env.apiUrl) {
  console.error('CRITICAL: VITE_API_URL is not configured!');
}

export default env;
